<ng-container *ngIf="visible">
    <a *ngIf="href; else internalItem" [id]="id" class="menu-link" [href]="href" [attr.target]="target"
        [class.menu-item-disabled]="disabled" (click)="externalClick.emit($event)">
        <div class="menu-item" [class.menu-item-selected]="selected" [class.menu-item-disabled]="disabled">
            <div *ngIf="showLaunchIcon; else plainExternalLabel" class="menu-link-item">
                <div class="menu-title">
                    {{ label }}
                </div>
                <div class="icon-container">
                    <mat-icon class="small-icon">launch</mat-icon>
                </div>
            </div>
            <ng-template #plainExternalLabel>{{ label }}</ng-template>
        </div>
    </a>

    <ng-template #internalItem>
        <button type="button" [id]="id" class="menu-item menu-item-button" [hidden]="hidden" [disabled]="disabled"
            [class.menu-item-selected]="selected" [class.menu-item-disabled]="disabled" (click)="itemClick.emit()">
            {{ label }}
        </button>
    </ng-template>
</ng-container>